/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { Flex, Text } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CountBadge from './CountBadge';
import c from '../../constant';
import useStore from '../../store';
import useCompanyReportStore from '../../store/company-report-persistent-store';

const QUERY_REPORTS = gql`
	query qCountFileReport(
		$pagerInput: PagerInput!
		$fromDate: DateTime
		$toDate: DateTime
		$companyName: String
		$type: CompanySubmissionReportTypes
		$reportType: CompanySubmissionReportTypesOfReport
		$newReportType: String
		$read: Boolean
		$spam: Boolean
	) {
		getCompanySubmissionReports(
			pagerInput: $pagerInput
			fromDate: $fromDate
			toDate: $toDate
			companyName: $companyName
			type: $type
			reportType: $reportType
			newReportType: $newReportType
			read: $read
			spam: $spam
		) {
			companySubmissionReports {
				id
			}
			countUnreadCompanySubmissionReports
		}
	}
`;

const QUERY_EWS_COUNT = gql`
	query countEWS($type: String) {
		getUnreadEarlyWarningStatementCount(type: $type)
	}
`;

const QUERY_MD_COUNT = gql`
	query countMD($reportId: String) {
		getCountUnreadNotifications(reportId: $reportId)
	}
`;

export default function ReportMenuItem({ item, index, reportId, callbackCountUnread }) {
	const { push } = useHistory();
	const { currentLang } = useStore((state) => state.currentLang);
	const [loadReports, { data }] = useLazyQuery(QUERY_REPORTS);
	const [loadEWSCount, { data: dataEWS }] = useLazyQuery(QUERY_EWS_COUNT);
	const [loadMDCount, { data: dataMD }] = useLazyQuery(QUERY_MD_COUNT);
	const { unreadReportCount } = useStore((state) => state.unreadReportCount);
	const { companyType, companyId } = useCompanyReportStore();

	useEffect(() => {
		if (data?.getCompanySubmissionReports) {
			callbackCountUnread(data?.getCompanySubmissionReports?.countUnreadCompanySubmissionReports);
		}
	}, [data]);

	useEffect(() => {
		if (dataEWS?.getUnreadEarlyWarningStatementCount) {
			callbackCountUnread(dataEWS?.getUnreadEarlyWarningStatementCount?.unreadEarlyWarningStatementCount);
		}
	}, [dataEWS]);

	useEffect(() => {
		if (dataMD) {
			callbackCountUnread(dataMD?.getCountUnreadNotifications);
		}
	}, [dataMD]);

	useEffect(() => {
		if (!unreadReportCount?.[item?.id]?.period) {
			if (item?.id && item?.path?.includes('company-submission-report/report')) {
				const limit = 1;
				const offset = 0;
				const pagerInput = { limit, offset };
				loadReports({
					variables: {
						pagerInput,
						read: false,
						newReportType: item?.id,
						spam: null,
					},
				});
			}

			if (
				item?.id === c.quarterly_report_on_investment ||
				item?.id === c.quarterly_financial_statements ||
				item?.id === c.annually_unaudited_financial_statements ||
				item?.id === c.annually_audited_financial_statements ||
				item?.id === c.annually_report_on_investment
			) {
				loadEWSCount({
					variables: {
						type: item?.id,
					},
				});
			}

			if (item?.id && item?.path?.includes('/market-development-data?')) {
				loadMDCount({
					variables: {
						type: 'COMPANY_SUBMISSION_MDD_REPORT',
						reportId: item?.id,
					},
				});
			}
		}
	}, [item]);

	function reportItemTitle(title) {
		const nkc1 = 'របាយការណ៍ហិរញ្ញវត្ថុប្រចាំឆ្នាំរបស់ក្រុមហ៊ុនធានារ៉ាប់រងមិនទាន់រងសវនកម្ម';
		const nec1 = 'Unaudited Financial Statement for Insurance Company';
		const nkc2 = 'របាយការណ៍ហិរញ្ញវត្ថុប្រចាំឆ្នាំរបស់ក្រុមហ៊ុនធានារ៉ាប់រងរងសវនកម្ម';
		const nec2 = 'Audited Financial Statement for Insurance Company';
		const nkc3 = 'របាយការណ៍ហិរញ្ញវត្ថុប្រចាំឆ្នាំរបស់គ្រឹះស្ថានធានារ៉ាប់រងមិនទាន់រងសវនកម្ម';
		const nec3 = 'Unaudited Financial Statement for Insurance Institute';
		const nkc4 = 'របាយការណ៍ហិរញ្ញវត្ថុប្រចាំឆ្នាំរបស់គ្រឹះស្ថានធានារ៉ាប់រងរងសវនកម្ម';
		const nec4 = 'Audited Financial Statement for Insurance Institute';
		const nkc5 = 'របាយការណ៍អាជីវកម្មរបស់ក្រុមហ៊ុនធានារ៉ាប់រងរងសវនកម្ម';
		const nec5 = 'Audited Sale Report for Insurance Company';
		const nkc6 = 'របាយការណ៍ទទួល និងដោះស្រាយសំណងរបស់ក្រុមហ៊ុនធានារ៉ាប់រងរងសវនកម្ម';
		const nec6 = 'Audited Receiving and Settling Claim Report for Insurance Company';
		const nkc7 = 'របាយការណ៍លក់តាមប្រព័ន្ធចែកចាយ និងតាមភូមិសាស្ត្ររបស់ក្រុមហ៊ុនធានារ៉ាប់រងរងសវនកម្ម';
		const nec7 = 'Audited Distribution Channels and Geographical Report for Insurance Company';
		const nkc8 = 'របាយការណ៍វិនិយោគរបស់ក្រុមហ៊ុនធានារ៉ាប់រងរងសវនកម្ម';
		const nec8 = 'Audited Report on Investment for Insurance Company';

		if (title === nkc1 || title === nec1) {
			if (title === nkc1) {
				return (
					<>
						របាយការណ៍ហិរញ្ញវត្ថុប្រចាំឆ្នាំរបស់ក្រុមហ៊ុនធានារ៉ាប់រង
						<span style={{ color: '#3182ce', fontWeight: 'bold' }}>មិនទាន់រងសវនកម្ម</span>
					</>
				);
			} else {
				return (
					<>
						<span style={{ color: '#3182ce', fontWeight: 'bold' }}>Unaudited&nbsp;</span>
						Financial Statement for Insurance Company
					</>
				);
			}
		} else if (title === nkc2 || title === nec2) {
			if (title === nkc2) {
				return (
					<>
						របាយការណ៍ហិរញ្ញវត្ថុប្រចាំឆ្នាំរបស់ក្រុមហ៊ុនធានារ៉ាប់រង
						<span style={{ color: '#3182ce', fontWeight: 'bold' }}>រងសវនកម្ម</span>
					</>
				);
			} else {
				return (
					<>
						<span style={{ color: '#3182ce', fontWeight: 'bold' }}>Audited&nbsp;</span>
						Financial Statement for Insurance Company
					</>
				);
			}
		} else if (title === nkc3 || title === nec3) {
			if (title === nkc3) {
				return (
					<>
						របាយការណ៍ហិរញ្ញវត្ថុប្រចាំឆ្នាំរបស់គ្រឹះស្ថានធានារ៉ាប់រង
						<span style={{ color: '#3182ce', fontWeight: 'bold' }}>មិនទាន់រងសវនកម្ម</span>
					</>
				);
			} else {
				return (
					<>
						<span style={{ color: '#3182ce', fontWeight: 'bold' }}>Unaudited&nbsp;</span>
						Financial Statement for Insurance Institute
					</>
				);
			}
		} else if (title === nkc4 || title === nec4) {
			if (title === nkc4) {
				return (
					<>
						របាយការណ៍ហិរញ្ញវត្ថុប្រចាំឆ្នាំរបស់គ្រឹះស្ថានធានារ៉ាប់រង
						<span style={{ color: '#3182ce', fontWeight: 'bold' }}>រងសវនកម្ម</span>
					</>
				);
			} else {
				return (
					<>
						<span style={{ color: '#3182ce', fontWeight: 'bold' }}>Audited&nbsp;</span>
						Financial Statement for Insurance Institute
					</>
				);
			}
		} else if (title === nkc5 || title === nec5) {
			if (title === nkc5) {
				return (
					<>
						របាយការណ៍អាជីវកម្មរបស់ក្រុមហ៊ុនធានារ៉ាប់រង
						<span style={{ color: '#3182ce', fontWeight: 'bold' }}>រងសវនកម្ម</span>
					</>
				);
			} else {
				return (
					<>
						<span style={{ color: '#3182ce', fontWeight: 'bold' }}>Audited&nbsp;</span>
						Sale Report for Insurance Company
					</>
				);
			}
		} else if (title === nkc6 || title === nec6) {
			if (title === nkc6) {
				return (
					<>
						របាយការណ៍ទទួល និងដោះស្រាយសំណងរបស់ក្រុមហ៊ុនធានារ៉ាប់រង
						<span style={{ color: '#3182ce', fontWeight: 'bold' }}>រងសវនកម្ម</span>
					</>
				);
			} else {
				return (
					<>
						<span style={{ color: '#3182ce', fontWeight: 'bold' }}>Audited&nbsp;</span>
						Receiving and Settling Claim Report for Insurance Company
					</>
				);
			}
		} else if (title === nkc7 || title === nec7) {
			if (title === nkc7) {
				return (
					<>
						របាយការណ៍លក់តាមប្រព័ន្ធចែកចាយ និងតាមភូមិសាស្ត្ររបស់ក្រុមហ៊ុនធានារ៉ាប់រង
						<span style={{ color: '#3182ce', fontWeight: 'bold' }}>រងសវនកម្ម</span>
					</>
				);
			} else {
				return (
					<>
						<span style={{ color: '#3182ce', fontWeight: 'bold' }}>Audited&nbsp;</span>
						Distribution Channels and Geographical Report for Insurance Company
					</>
				);
			}
		} else if (title === nkc8 || title === nec8) {
			if (title === nkc8) {
				return (
					<>
						របាយការណ៍វិនិយោគរបស់ក្រុមហ៊ុនធានារ៉ាប់រងរងសវនកម្ម
						<span style={{ color: '#3182ce', fontWeight: 'bold' }}>រងសវនកម្ម</span>
					</>
				);
			} else {
				return (
					<>
						<span style={{ color: '#3182ce', fontWeight: 'bold' }}>Audited&nbsp;</span>
						Report on Investment for Insurance Company
					</>
				);
			}
		}
		return title;
	}

	function reportItem(item, index) {
		return (
			<Flex
				_hover={{ backgroundColor: `${reportId === item?.id ? 'rgba(52, 152, 219,.1)' : 'gray.50'}` }}
				key={index}
				onMouseDown={() => {
					let params = {};
					let gloabalQueries = '';

					if (companyType) {
						params['companyType'] = companyType || null;
					}

					if (companyId) {
						params['companyId'] = companyId || null;
					}

					let queries =
						Object.keys(params)
							.map((key) => key + '=' + params[key])
							.join('&') || '';

					if (queries) {
						gloabalQueries = '&' + queries;
					}

					push(item?.path + gloabalQueries);
				}}
				width="100%"
				alignItems="center"
				bg={`${reportId === item?.id ? 'rgba(52, 152, 219,.1)' : 'white'}`}
				borderRadius={c.borderRadius}
				border={`1px solid ${reportId === item?.id ? '#3498db' : '#dbdbdb'}`}
				boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
				p="2"
				cursor="pointer"
				mb="4"
			>
				<Text w="100%" fontWeight="bold" color="black.500">
					{currentLang === 'kh' ? reportItemTitle(item?.titleKh) : reportItemTitle(item?.title)}
					{item?.hint && <span style={{ marginLeft: '4px', color: '#3182ce', fontWeight: 'bold' }}>{item?.hint}</span>}
				</Text>
				<CountBadge reportId={item?.id} />
			</Flex>
		);
	}

	return reportItem(item, index);
}
